interface IHubDataset {
    id: number;
    date: string;
    createdOn: string;
}

export default IHubDataset;

export enum AutomationTypes {
    Site = 0,
    Controls = 1,
}
